import { About1, About2, About3, About9, About10 } from "./aboutParts1";

export const About11 = () => (
  <div class="space-y-6 text-lg md:text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
    <p>Three forces make this the perfect moment:</p>
    <div class="space-y-6 mt-8">
      <div class="bg-white dark:bg-neutral-900 rounded-2xl p-6 shadow-sm">
        <h3 class="text-2xl font-bold mb-3 text-gray-600 dark:text-gray-200">AI Maturity</h3>
        <p class="text-lg text-gray-700 dark:text-gray-300">
          We can now synthesize expert knowledge at scale while maintaining maintaining consistent quality — something impossible even two years ago.
        </p>
      </div>
      <div class="bg-white dark:bg-neutral-900 rounded-2xl p-6 shadow-sm">
        <h3 class="text-2xl font-bold mb-3 text-gray-600 dark:text-gray-200">Scrolling Fatigue</h3>
        <p class="text-lg text-gray-700 dark:text-gray-300">
          People increasingly recognize their digital habits aren't serving them and actively seek better alternatives to mindless consumption.
        </p>
      </div>
      <div class="bg-white dark:bg-neutral-900 rounded-2xl p-6 shadow-sm">
        <h3 class="text-2xl font-bold mb-3 text-gray-600 dark:text-gray-200">Mobile-First content</h3>
        <p class="text-lg text-gray-700 dark:text-gray-300">
          The generation that grew up on smartphones wants content designed for how they actually use their phones, not desktop experiences awkwardly squeezed
          onto phones.
        </p>
      </div>
    </div>
  </div>
);

export const About12 = () => (
  <section class="mt-10">
    <About10 />
    <About11 />
  </section>
);

export const About13 = () => (
  <>
    <h2 class="text-2xl md:text-5xl font-bold mb-8 text-gray-900 dark:text-white">What We're Not</h2>
    <div class="space-y-4">
      <div class="p-6 border-2 border-gray-200 dark:border-gray-700 rounded-xl">
        <h3 class="text-xl font-bold mb-2 text-gray-900 dark:text-white">Not a News Platform</h3>
        <p class="text-gray-600 dark:text-gray-200">No breaking updates or anxiety triggers</p>
      </div>
      <div class="p-6 border-2 border-gray-200 dark:border-gray-700 rounded-xl">
        <h3 class="text-xl font-bold mb-2 text-gray-900 dark:text-white">Not Social Media</h3>
        <p class="text-gray-600 dark:text-gray-200">No posting, no performing, no comparing yourself to others — just reading</p>
      </div>
      <div class="p-6 border-2 border-gray-200 dark:border-gray-700 rounded-xl">
        <h3 class="text-xl font-bold mb-2 text-gray-900 dark:text-white">Not Clickbait</h3>
        <p class="text-gray-600 dark:text-gray-200">Every headline delivers on its promise</p>
      </div>
      <div class="p-6 border-2 border-gray-200 dark:border-gray-700 rounded-xl">
        <h3 class="text-xl font-bold mb-2 text-gray-900 dark:text-white">Not an Echo Chamber</h3>
        <p class="text-gray-600 dark:text-gray-200">We show you different perspectives, not just what you already agree with</p>
      </div>
      <div class="p-6 border-2 border-gray-200 dark:border-gray-700 rounded-xl">
        <h3 class="text-xl font-bold mb-2 text-gray-900 dark:text-white">Not Elitist</h3>
        <p class="text-gray-600 dark:text-gray-200">Good ideas explained clearly, no jargon required</p>
      </div>
    </div>
  </>
);

export const About14 = () => (
  <section class="mt-10">
    <About13 />
  </section>
);

export const About15 = () => (
  <section class="mt-10 py-10 px-4 rounded-2xl bg-gradient-to-br text-gray-900 dark:text-white text-center">
    <h2 class="text-xl md:text-2xl font-bold mb-6">The Future We're Building</h2>
    <p class="text-xl md:text-2xl mb-8 opacity-90">
      A world where mindless scrolling becomes time well spent. Where the same phones that scattered our attention help us feel better about the time we spend
      on our phones.
    </p>
    <p class="text-lg mb-6 opacity-90">
      This isn't just another content app—it's a practical bet on people's hunger for substance. We believe curiosity deserves better than what algorithms feed
      us, not just engagement metrics.
    </p>
    <p class="text-lg italic opacity-80">One article at a time.</p>
    <p class="text-2xl font-semibold mt-8">Until scrolling stops feeling like a waste.</p>
  </section>
);

export const About16 = () => (
  <div class="px-6 py-12">
    <About1 />
    <About2 />
    <About3 />
    <About9 />
    <About12 />
    <About14 />
    <About15 />
  </div>
);

export const AboutRoot = () => (
  <div class="min-h-screen rounded-2xl bg-white dark:bg-neutral-900 text-gray-900 dark:text-gray-100">
    <About16 />
  </div>
);
